import { makeStyledComponent } from '@apia/theme';
import { Component, ReactNode } from 'react';
import { Box, Heading, Paragraph } from '@apia/theme';

const Error = makeStyledComponent(
  'Error',
  'layout.panels.error',
  {
    '.panelError__wrapper': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,

      h3: {
        color: 'palette.error.main',
      },
    },
  },
  ({ error }: { error: string }) => {
    return (
      <Box className="panelError__wrapper">
        <Heading as="h3">Oops! Something went wrong</Heading>
        <Heading as="h4">Error:</Heading>
        <Paragraph>{error}</Paragraph>
      </Box>
    );
  },
);

export class PanelErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean; errorMessage: string }
> {
  state: Readonly<{ hasError: boolean; errorMessage: string }> = {
    hasError: false,
    errorMessage: '',
  };

  static getDerivedStateFromError(error: unknown) {
    if (!(error instanceof Promise))
      return { hasError: true, errorMessage: String(error) };
  }

  render() {
    if (this.state.hasError) {
      return <Error error={this.state.errorMessage} />;
    }

    return this.props.children;
  }
}
